module.exports = __webpack_public_path__ + "static/text-364e57a45197529065f97e6b479d198d.png";